import { ColorSwatch, displayOrNone, Row } from 'components/production/components/AisleContent/SummaryComponents';

/**
 * Summary view for the Product Spotlight editor.
 *
 * @param {Object} data - Non-configurable carousel data.
 * @param {Object} formData - Product spotlight data.
 */
export default function ProductSpotlightEditorSummary({ data, formData }) {
    const products = formData.items ?? [];

    return (
        <div className="grid grid-cols-[max-content_1fr] gap-y-1 gap-x-8 items-baseline">
            <Row label="id">
                <p className="text-sm">{displayOrNone(data.id)}</p>
            </Row>
            <Row label="Primary image" labelClass="mb-0.5">
                <SpotlightImage imageUrl={formData.imageUrl} />
            </Row>
            <Row label="Background image" labelClass="mb-0.5">
                <SpotlightImage imageUrl={formData.backgroundImageUrl} />
            </Row>
            <Row label="Eyebrow">
                <p className="text-sm">{displayOrNone(formData.eyebrow)}</p>
            </Row>
            <Row label="Name">
                <p className="text-sm">{displayOrNone(formData.name)}</p>
            </Row>
            <Row label="Description">
                <p className="text-sm">{displayOrNone(formData.description)}</p>
            </Row>
            <Row label="Link Text">
                <p className="text-sm">{displayOrNone(formData.linkText)}</p>
            </Row>
            <Row label="Link URL">
                <p className="text-sm">{displayOrNone(formData.linkUrl)}</p>
            </Row>
            <Row label="Products">
                <p className="text-sm">
                    {products.length > 0
                        ? products
                              .map((product) => `${product.externalSku || product.external_sku}: ${product.name}`)
                              .join(', ')
                        : displayOrNone(null)}
                </p>
            </Row>
            <Row label="Background Color" labelClass="transform -translate-y-1">
                <ColorSwatch color={formData.bgColor} />
            </Row>
        </div>
    );
}

/**
 * Displays a spotlight image or "None" placeholder.
 *
 * @param {string} imageUrl - The image URL.
 */
function SpotlightImage({ imageUrl }) {
    if (!imageUrl) {
        return <span className="italic text-muted-foreground">None</span>;
    }

    const imageCdnUrl = 'https://img-cdn.misfitsmarket.com/';
    const src = `${imageCdnUrl}${imageUrl.replace(imageCdnUrl, '')}`;

    return <img alt="" className="max-w-60 h-15 rounded border" src={src} />;
}
